import apiClient from 'api/apiClient';

// eslint-disable-next-line import/prefer-default-export
export const getExternalInvestors = ([externalInvestorsClassNames, institutionId]) => apiClient.get('/v1/external_investors', {
  params: {
    externalInvestorsClassNames,
    institutionId,
  },
});
